/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import InputField from "~components/Form/components/InputField";
import ContainerForm from "~components/Form/components/ContainerForm";

import { Checkbox, FormLabel, Spinner } from "@chakra-ui/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { IconSuccess, WarningIcon2, SimulatorsTrash, DuplicateIcon } from "~misc/icons";

import Select from "~components/Form/components/Select";
import Loader from "~components/Form/components/Loader";
import PriceInput from "~components/Form/components/PriceInput";
import { getTrilhaCliente, removingFormatting } from "~services/GlobalServices";
import MessageForm from "~components/Form/components/MessageForm";
import { getLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useAll from "~/fetchs/useAll";
import { initialPath } from "~misc/paths";
import ModalAction from "~components/Modal/ModalAction";
import useModalAction from "~components/Modal/hooks/useModalAction";
import usePesquisaMedida from "~/fetchs/PriceSearch/usePesquisaMedida";
import usePesquisaPrazo from "~/fetchs/PriceSearch/usePesquisaPrazo";
import usePesquisaEmbalagem from "~/fetchs/PriceSearch/usePesquisaEmbalagem";
import usePesquisaCanalDistribuicao from "~/fetchs/PriceSearch/usePesquisaCanalDistribuicao";
import usePesquisaPlayer from "~/fetchs/PriceSearch/usePesquisaPlayer";
import usePesquisaProdutos from "~/fetchs/PriceSearch/usePesquisaProdutos";
import usePesquisaGrupoMaterial from "~/fetchs/PriceSearch/usePesquisaGrupoMaterial";
import { db } from "~/db/db";

import Info from "~components/Form/components/Info";
import { getNavigationState } from "~services/utils/NavigationUtils";
import usePesquisaCentroOrigem from "~/fetchs/PriceSearch/usePesquisaCentroOrigem";
import usePesquisaMotivoCompra from "~/fetchs/PriceSearch/usePesquisaMotivoCompra";
import useUnsavedChangesWarning from "~components/Form/hooks/useUnsavedChangesWarning";

import usePriceSearchForm from "../hooks/usePriceSearchForm";
import { checkTodaySearchs, formatDateToCustomString } from "../utils/searchHelpers";

const PriceSearchForm = ({ dados, setShowButton, origens, getOrigem, origem, cameFromVisitaView }) => {
  const {
    isModalOpenAction: isModalDeleteOpenAction,
    closeModalAction: closeModalDeleteAction,
    openModalAction: openModalDeleteAction,
  } = useModalAction();

  const {
    isModalOpenAction: isModalRepeatedOpenAction,
    closeModalAction: closeModalRepeatedAction,
    openModalAction: openModalRepeatedAction,
  } = useModalAction();

  const [showMessageForm, setShowMessageForm] = useState({
    text: "",
    type: "success",
    icon: IconSuccess,
  });

  const formikRef = useRef();
  const [firstFormikApply, setFirstFormikApply] = useState(true);

  const [trilhaCliente, setTrilhaCliente] = useState("");
  const [pesquisaData, setPesquisaData] = useState({});
  const [duplicarPesquisa, setDuplicarPesquisa] = useState({});
  const [pesquisaRepetidaId, setPesquisaRepetidaId] = useState(undefined);
  const [permitirEmbalagem, setPermitirEmbalagem] = useState(0);
  const [permitirPlayer, setPermitirPlayer] = useState(0);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (dados?.trilha) setTrilhaCliente(getTrilhaCliente(dados.trilha?.codigo));
  }, [dados]);

  const initializePermissionId = ({ id, setId = () => {} }) => {
    if (id) {
      if (typeof setId == "function") setId(id);
    }
  };

  const {
    optionPesquisaGrupoMaterial,
    onChangePesquisaGrupoMaterial,
    pesquisaGrupoMaterialSelect,
    pesquisaGrupoMaterial,
    setPesquisaGrupoMaterialSelect,
  } = usePesquisaGrupoMaterial(formikRef);

  const { optionPesquisaProduto, onChangePesquisaProduto, pesquisaProdutoSelect, setPesquisaProdutoSelect } =
    usePesquisaProdutos(formikRef, pesquisaGrupoMaterial);

  const {
    optionPesquisaCanalDistribuicao,
    onChangePesquisaCanalDistribuicao,
    pesquisaCanalDistribuicaoSelect,
    setPesquisaCanalDistribuicaoSelect,
  } = usePesquisaCanalDistribuicao(formikRef, pesquisaGrupoMaterial);

  const {
    optionPesquisaEmbalagem,
    onChangePesquisaEmbalagem,
    pesquisaEmbalagemSelect,
    pesquisaEmbalagem,
    setPesquisaEmbalagemSelect,
  } = usePesquisaEmbalagem({
    formikRef,
    pesquisaGrupoMaterialId: pesquisaGrupoMaterial,
    permitir: permitirEmbalagem,
    showAll: false,
  });

  const {
    optionPesquisaMedida,
    onChangePesquisaMedida,
    pesquisaMedidaSelect,
    setPesquisaMedidaSelect,
    pesquisaMedidasSelectEnabled,
  } = usePesquisaMedida(formikRef, dados?.trilha?.codigo, pesquisaEmbalagem, pesquisaGrupoMaterial);

  const {
    optionPesquisaPlayer,
    onChangePesquisaPlayer,
    pesquisaPlayerSelect,
    pesquisaPlayer,
    setPesquisaPlayerSelect,
  } = usePesquisaPlayer({
    formikRef,
    grupoMaterialId: pesquisaGrupoMaterial,
    permitir: permitirPlayer,
    showAll: false,
  });

  const optionPesquisaPlayerSorted = React.useMemo(() => {
    const opts = optionPesquisaPlayer || [];
    return opts.slice().sort((a, b) => {
      const la = (a?.label ?? "").toString();
      const lb = (b?.label ?? "").toString();
      return la.localeCompare(lb, undefined, { sensitivity: "base" });
    });
  }, [optionPesquisaPlayer]);

  const {
    optionPesquisaPrazo,
    onChangePesquisaPrazo,
    pesquisaPrazoSelect,
    setPesquisaPrazoSelect,
    mostrarPrazoPersonalizado,
  } = usePesquisaPrazo(formikRef, pesquisaGrupoMaterial, dados?.trilha?.codigo);

  const {
    optionPesquisaCentroOrigem,
    onChangePesquisaCentroOrigem,
    pesquisaCentroOrigemSelect,
    setPesquisaCentroOrigemSelect,
  } = usePesquisaCentroOrigem({ formikRef, pesquisaPlayerId: pesquisaPlayer });

  const {
    optionPesquisaMotivoCompra,
    onChangePesquisaMotivoCompra,
    pesquisaMotivoCompraSelect,
    setPesquisaMotivoCompraSelect,
  } = usePesquisaMotivoCompra({ formikRef });
  const { incotermsSelect, incoterms, setIncoterms, onChangeIncoterms } = useAll(formikRef);

  useEffect(() => {
    if (permitirEmbalagem) {
      setPesquisaEmbalagemSelect(permitirEmbalagem, "teste");
    }
  }, [optionPesquisaEmbalagem]);

  useEffect(() => {
    if (permitirPlayer) {
      setPesquisaPlayerSelect(permitirPlayer);
    }
  }, [optionPesquisaPlayer]);

  const {
    validationSchemaIND,
    validationSchemaTAC,
    optionSelect,
    editForm,
    validationSchemaEditIND,
    validationSchemaEditTAC,
    valuesInd,
    valuesTac,
  } = usePriceSearchForm({ prazoPersonalizado: mostrarPrazoPersonalizado });

  const [loading, setLoading] = useState(false);
  const [sellIn, setSellIn] = useState("");
  const [sellOut, setSellOut] = useState("");
  const [precoFob, setPrecoFob] = useState("");
  const [precoCif, setPrecoCif] = useState("");

  const { parameter: idCliente, number: idPesquisa } = useParams();

  async function setInputs(obj) {
    for (const [key, value] of Object.entries(obj)) {
      onChangeInput(key, value);
    }
  }

  const onChangeInput = (input, value) => {
    if (formikRef?.current) {
      formikRef.current.setFieldValue(input, value);
      setTimeout(() => formikRef.current.setFieldTouched(input, true));
    }
  };

  useEffect(() => {
    checkOrigem();
  }, []);

  async function checkOrigem() {
    const origem = getOrigem();

    if (origem == origens.editar_pesquisa) {
      setDuplicarPesquisa(getLocalStorage("duplicar-pesquisa", true));
    }
  }

  useEffect(() => {
    if (duplicarPesquisa && Object.entries(duplicarPesquisa)?.length > 0) {
      setPesquisaData(duplicarPesquisa);
    }
  }, [duplicarPesquisa]);

  useEffect(() => {
    const optionIncoterms = (optionSelect.incoterms || []).find((optIncoterms) => optIncoterms.value == incoterms);

    if (optionIncoterms) onChangeIncoterms(optionIncoterms);
  }, [incoterms]);

  const [checkNoInfoVolume, setCheckNoInfoVolume] = useState(false);
  const [checkNoConsumptionVolume, setCheckNoConsumptionVolume] = useState(false);
  const [checkNoInfoSellIn, setCheckNoInfoSellIn] = useState(false);

  const [checkNoInfoFob, setCheckNoInfoFob] = useState(false);
  const [checkNoInfoCif, setCheckNoInfoCif] = useState(false);

  useEffect(() => {
    if(checkNoInfoVolume) {
      setCheckNoConsumptionVolume(false);
    }
  }, [checkNoInfoVolume])

  useEffect(() => {
    if(checkNoConsumptionVolume) {
      setCheckNoInfoVolume(false);
    }
  }, [checkNoConsumptionVolume])

  useEffect(() => {
    if (formikRef?.current && Object.entries(pesquisaData)?.length > 0 && firstFormikApply) {
      setPesquisaGrupoMaterialSelect(pesquisaData.pesquisaGrupoMaterialId);
      setPesquisaProdutoSelect(pesquisaData.pesquisaProdutoId);
      initializePermissionId({ id: pesquisaData.pesquisaEmbalagemId, setId: setPermitirEmbalagem });
      initializePermissionId({ id: pesquisaData.pesquisaPlayerId, setId: setPermitirPlayer });
      setPesquisaCentroOrigemSelect(pesquisaData.pesquisaCentroOrigemId);
      setPesquisaCanalDistribuicaoSelect(pesquisaData.pesquisaCanalDistribuicaoId);
      setPesquisaMotivoCompraSelect(pesquisaData.pesquisaMotivoCompraId);
      setIncoterms(pesquisaData.incoterms);

      if (duplicarPesquisa && Object.entries(duplicarPesquisa)?.length == 0) {
        setInputs({
          volume: pesquisaData.volume,
          outrosPrazos: pesquisaData.outrosPrazos,
          volumeNoInfo: pesquisaData.volume === '' || pesquisaData.volume === null,
          volumeNoConsumption: pesquisaData.volume === 0,
          noInfoPrecoFob: pesquisaData.precoFOB == 0,
          noInfoPrecoCif: pesquisaData.precoCIF == 0,
          noInfoSellIn: pesquisaData.sellIn == 0,
        });

        setCheckNoInfoVolume(pesquisaData.volume === '' || pesquisaData.volume === null);
        setCheckNoConsumptionVolume(pesquisaData.volume === 0);

        setPesquisaPrazoSelect(pesquisaData.pesquisaPrazoId);

        setSellIn(pesquisaData.sellIn);
        setCheckNoInfoSellIn(pesquisaData.sellIn == 0);

        setSellOut(pesquisaData.sellOut);

        setPrecoFob(pesquisaData.precoFOB);
        setCheckNoInfoFob(pesquisaData.precoFOB == 0);

        setPrecoCif(pesquisaData.precoCIF);
        setCheckNoInfoCif(pesquisaData.precoCIF == 0);

        setPesquisaMedidaSelect(pesquisaData.pesquisaUnidadeMedidaId);
      }

      setFirstFormikApply(false);
    }
  }, [formikRef?.current, pesquisaData]);

  const fetchData = async () => {
    const id = idPesquisa?.length < 15 ? parseInt(idPesquisa) : idPesquisa;
    const filter = await db.mapaDaMina
      .where("id")
      .equals(id)
      .and((c) => c.clienteId == parseInt(idCliente))
      .first();

    if (idCliente && idPesquisa && filter) {
      setPesquisaData(filter);
    }
  };

  useEffect(() => {
    if (idPesquisa > 0) {
      fetchData();
    }
  }, [idPesquisa]);

  useEffect(() => {
    if (idPesquisa > 0) {
      editForm();
    }
  }, []);

  async function toDelete() {
    openModalDeleteAction();
  }

  async function deleteConfirmed() {
    if (idPesquisa != 0) {
      setLoading(true);
      setShowButton(false);

      const params = new URLSearchParams();
      params.append("origem", origens.editar_pesquisa);
      params.append("deletar", idPesquisa);
      if (cameFromVisitaView) params.append("cameFromVisitaView", cameFromVisitaView);

      navigate(`${initialPath}/pesquisa-de-preco/${idCliente}?${params.toString()}`);
    }
    closeModalDeleteAction();
  }

  async function toDuplicate() {
    if (Object.entries(pesquisaData)?.length > 0) {
      const toSend = {
        pesquisaGrupoMaterialId: pesquisaData.pesquisaGrupoMaterialId,
        pesquisaProdutoId: pesquisaData.pesquisaProdutoId,
        pesquisaEmbalagemId: pesquisaData.pesquisaEmbalagemId,
        pesquisaPlayerId: pesquisaData.pesquisaPlayerId,
        pesquisaCentroOrigemId: pesquisaData.pesquisaCentroOrigemId,
        pesquisaMotivoCompraId: pesquisaData.pesquisaMotivoCompraId,
        incoterms: pesquisaData.incoterms,
        pesquisaCanalDistribuicaoId: pesquisaData.pesquisaCanalDistribuicaoId,
        contextoId: pesquisaData.contextoId,
        localId: pesquisaData.localId,
        contato: pesquisaData.contato,
      };

      saveLocalStorage("duplicar-pesquisa", toSend, true);

      navigate(
        `${initialPath}/pesquisa-de-preco/${idCliente}/nova-pesquisa?origem=${origens.editar_pesquisa}${
          searchParams.get("cameFromVisitaView") ? "&cameFromVisitaView=true" : ""
        }`
      );
    }
  }

  const salvar = async (data) => {
    setLoading(false);

    let update = idPesquisa !== undefined;
    let create = !update;
    const formatToday = formatDateToCustomString(new Date());

    const repeated = async (data) => {
      const results = [];
      await db.mapaDaMina
        .where("pesquisaProdutoId")
        .equals(data.pesquisaProdutoId)
        .and(
          (c) =>
            c.ativo &&
            c.pesquisaPlayerId == data.pesquisaPlayerId &&
            c.pesquisaCanalDistribuicaoId == data.pesquisaCanalDistribuicaoId &&
            c.pesquisaEmbalagemId == data.pesquisaEmbalagemId &&
            c.incoterms == data.incoterms &&
            c.id != data.id
        )
        .and((item) => item.clienteId === parseInt(idCliente))
        .each((c) => results.push(c));

      results.sort((a, b) => a.createdAt - b.createdAt);

      return results?.length > 0 ? results[results?.length - 1] : null;
    };

    const checkForKey = async ({ id, data }) => {
      const searchId = id?.length == 15 ? id.toString() : parseInt(id);
      const result = await db.mapaDaMina
        .where("id")
        .equals(searchId)
        .and(
          (c) =>
            data.pesquisaProdutoId == c.pesquisaProdutoId &&
            data.pesquisaPlayerId == c.pesquisaPlayerId &&
            data.pesquisaCanalDistribuicaoId == c.pesquisaCanalDistribuicaoId &&
            data.pesquisaEmbalagemId == c.pesquisaEmbalagemId
        )
        .first();

      return result;
    };

    const getIdParsed = (id) => (id && id?.length < 15 ? parseInt(id) : id.toString());

    //CASO EXISTA, PRECISAMOS DE UM MODAL PARA DECIDIR SE VAI QUERER REDIRECIONAR PARA A EDIÇÃO DO ITEM OU NÃO.
    const repeatedValue = await repeated(data);

    if (repeatedValue) {
      openModalRepeatedAction();
      setPesquisaRepetidaId(repeatedValue.id);
      return;
    }

    await checkTodaySearchs({
      clienteId: parseInt(idCliente),
      pesquisaId: idPesquisa ?? null,
      obj: idPesquisa ? { ...data } : {},
    });

    if (update) {
      const toUpdateId = getIdParsed(idPesquisa);

      //REALIZA UMA CHECAGEM PARA VERIFICAR SE OS DADOS GERAIS AINDA SÃO OS MESMOS.
      //PRODUTO, PLAYER, CANAL DE DISTRIBUIÇÃO E EMBALAGEM
      //SE FOREM DIFERENTE, DELETAMOS A PESQUISA PELO ID, E CRIAMOS UMA NOVA COM OS DADOS NOVOS
      const same = await checkForKey({ id: toUpdateId, data });

      //SE FOR NULO OU UNDEFINED, SÃO DADOS DIFERENTES
      if (!same) {
        await db.mapaDaMina.update(toUpdateId, {
          ativo: false,
          deletadoEm: formatDateToCustomString(new Date()),
          updated: true,
        });
        create = true;
      } else {
        await db.mapaDaMina.update(toUpdateId, {
          ...data,
          volume: typeof data.volume == 'string' && data.volume.length == 0 ? null : data.volume,
          id: toUpdateId,
          updated: true,
          updatedAt: formatToday,
        });
      }
    }

    if (create) {
      await db.mapaDaMina.add({
        ...data,
        id: Date.now().toString().padStart(15, "0"),
        ativo: true,
        new: true,
        createdAt: formatToday,
        updatedAt: formatToday,
      });
    }

    setShowMessageForm({
      text: `${idPesquisa ? "Atualizado" : "Cadastrado"} com sucesso`,
      icon: IconSuccess,
      type: "success",
    });

    setShowButton(false);
  };

  const error = (error) => {
    setLoading(false);

    setShowMessageForm({
      text: `Ocorreu um erro durante o envio da pesquisa - ${error ?? ""}`,
      icon: WarningIcon2,
      type: "error",
    });
  };

  const mascaraOutrosPrazos = (str) => {
    return str.endsWith("/") ? str.slice(0, -1) : str;
  };

  // Helper function to process optional fields
  const getOptionalValue = (value) => {
    return value && value !== "" ? value : null;
  };

  // Helper function to build the information object
  const buildNovaInformacao = (values) => {
    return {
      clienteId: parseInt(idCliente),
      pesquisaGrupoMaterialId: values.grupoMaterialId,
      pesquisaPlayerId: values.empresaId,
      pesquisaProdutoId: values.produtoId,
      pesquisaCanalDistribuicaoId: getOptionalValue(values.canalDistribuicaoId),
      pesquisaEmbalagemId: values.embalagemId,
      incoterms: getOptionalValue(values.incoterms),
      pesquisaCentroOrigemId: getOptionalValue(values.pesquisaCentroOrigemId),
      pesquisaMotivoCompraId: getOptionalValue(values.pesquisaMotivoCompraId),
      volume: values.volume,
      pesquisaUnidadeMedidaId: values.unidadeMedidaId,
      pesquisaPrazoId: values.prazoId,
      sellIn: removingFormatting(values.sellIn),
      sellOut: removingFormatting(values.sellOut),
      precoCIF: removingFormatting(values.precoFinalCif),
      precoFOB: removingFormatting(values.precoFinalFob),
      frete: removingFormatting(values.frete),
      outrosPrazos: values.outrosPrazos && values.prazoId === null ? mascaraOutrosPrazos(values.outrosPrazos) : null,
      ultimaAtualizacao: formatDateToCustomString(new Date()),
    };
  };

  const handleSubmit = (values) => {
    const novaInformacao = buildNovaInformacao(values);

    if (idPesquisa > 0) {
      novaInformacao.id = idPesquisa?.length < 15 ? parseInt(idPesquisa) : idPesquisa;
    }

    if (Object.keys(novaInformacao)?.length > 0) {
      try {
        salvar(novaInformacao);
        const navigationState = getNavigationState();
      } catch (err) {
        error(err);
      }
    }
  };

  const validationForm = trilhaCliente === "IND" ? validationSchemaIND : validationSchemaTAC;

  const [isFormDirty, setIsFormDirty] = useState(false);
  const [valuesInputs, setValuesInputs] = useState({
    outrosPrazos: null,
    volume: null,
  });

  useUnsavedChangesWarning(isFormDirty, navigate, "Voltar");

  const handleValue = (name, value) => {
    setIsFormDirty(true);
  };

  useEffect(() => {
    if (valuesInputs.outrosPrazos !== null || valuesInputs.volume !== null) {
      setIsFormDirty(true);
    }
  }, [valuesInputs]);

  const getValidationSchema = () => {
    if (idCliente && idPesquisa) {
      return trilhaCliente === "IND" ? validationSchemaEditIND : validationSchemaEditTAC;
    }
    return validationForm;
  };

  return (
    <div data-testid="price-search-form">
      {idPesquisa && (!trilhaCliente || Object.entries(pesquisaData)?.length == 0) ? (
        <div className="container flex items-center justify-center">
          <Spinner size={"xl"} thickness="4px" />
        </div>
      ) : (
        <Formik
          innerRef={formikRef}
          initialValues={trilhaCliente === "IND" ? valuesInd : valuesTac}
          validateOnBlur={true}
          validationSchema={getValidationSchema()}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ errors, touched, setFieldValue, isSubmitting }) => (
            <>
              <Form id="emissor" className={idCliente && idPesquisa ? "edit relative" : "relative"}>
                <div className={loading ? "relative spinner__form-active" : "relative"}>
                  <ContainerForm title="Dados Gerais">
                    <div className="grid gap-x-4 grid-cols-1 xs:grid-cols-2">
                      <div>
                        <Select
                          name="grupoMaterialId"
                          label="*Grupo Produto:"
                          placeholder=""
                          options={optionPesquisaGrupoMaterial}
                          noOptionsMessage="Grupo não encontrado"
                          onChange={(e) => {
                            handleValue("grupoMaterialId", e);
                            onChangePesquisaGrupoMaterial(e);
                          }}
                          errors={errors.grupoMaterialId}
                          touched={touched.grupoMaterialId}
                          {...pesquisaGrupoMaterialSelect}
                        />
                      </div>
                      <div>
                        <div className="flex gap-x-2 mt-[3px]">
                          <FormLabel className="field__label">*Player: </FormLabel>
                        </div>
                        <Select
                          name="playerId"
                          label=""
                          placeholder=""
                          options={optionPesquisaPlayerSorted}
                          noOptionsMessage="Player não encontrado"
                          onChange={(e) => {
                            handleValue("playerId", e);
                            onChangePesquisaPlayer(e);
                          }}
                          errors={errors.empresaId}
                          touched={touched.empresaId}
                          {...pesquisaPlayerSelect}
                        />
                      </div>
                      <div>
                        <Select
                          name="embalagemId"
                          label="*Embalagem / Capacidade:"
                          placeholder=""
                          options={optionPesquisaEmbalagem}
                          noOptionsMessage="Embalagem não encontrado"
                          onChange={(e) => {
                            handleValue("embalagemId", e);
                            onChangePesquisaEmbalagem(e);
                          }}
                          errors={errors.embalagemId}
                          touched={touched.embalagemId}
                          {...pesquisaEmbalagemSelect}
                        />
                      </div>
                      <div>
                        <Select
                          name="produtoId"
                          label="*Produto: "
                          placeholder=""
                          options={optionPesquisaProduto}
                          noOptionsMessage="Produto não encontrado"
                          onChange={(e) => {
                            handleValue("produtoId", e);
                            onChangePesquisaProduto(e);
                          }}
                          errors={errors.produtoId}
                          touched={touched.produtoId}
                          {...pesquisaProdutoSelect}
                        />
                      </div>
                      <div>
                        <Select
                          name="incoterms"
                          label="*Modal (Incoterms)"
                          placeholder=""
                          options={optionSelect.incoterms}
                          noOptionsMessage="Incoterms não encontrado"
                          onChange={(e) => {
                            handleValue("incoterms", e);
                            onChangeIncoterms(e);
                          }}
                          errors={errors.incoterms}
                          touched={touched.incoterms}
                          {...incotermsSelect}
                        />
                      </div>

                      <div>
                        <Select
                          name="canalDistribuicaoId"
                          label="*Canal de Distribuição:"
                          placeholder=""
                          options={optionPesquisaCanalDistribuicao}
                          noOptionsMessage="Canal de Distribuição não encontrado"
                          onChange={(e) => {
                            handleValue("canalDistribuicaoId", e);
                            onChangePesquisaCanalDistribuicao(e);
                          }}
                          errors={errors.canalDistribuicaoId}
                          touched={touched.canalDistribuicaoId}
                          {...pesquisaCanalDistribuicaoSelect}
                        />
                      </div>
                      {trilhaCliente === "IND" && (
                        <>
                          <div>
                            <Select
                              name="pesquisaCentroOrigemId"
                              label="Origem (Centro):"
                              placeholder=""
                              options={optionPesquisaCentroOrigem}
                              noOptionsMessage="Centro/Origem não encontrado"
                              onChange={(e) => {
                                handleValue("pesquisaCentroOrigemId", e);
                                onChangePesquisaCentroOrigem(e);
                              }}
                              errors={errors.pesquisaCentroOrigemId}
                              touched={touched.pesquisaCentroOrigemId}
                              {...pesquisaCentroOrigemSelect}
                            />
                          </div>
                          <div>
                            <Select
                              name="pesquisaMotivoCompraId"
                              label="Motivo da Compra:"
                              placeholder=""
                              options={optionPesquisaMotivoCompra}
                              noOptionsMessage="Motivo da Compra não encontrado"
                              onChange={(e) => {
                                handleValue("pesquisaMotivoCompraId", e);
                                onChangePesquisaMotivoCompra(e);
                              }}
                              errors={errors.pesquisaMotivoCompraId}
                              touched={touched.pesquisaMotivoCompraId}
                              {...pesquisaMotivoCompraSelect}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </ContainerForm>
                  <ContainerForm title="Informações Adicionais">
                    <div className="grid gap-x-4 grid-cols-1 xs:grid-cols-2">
                      <div>
                        <InputField
                          onKeyDown={(e) => {
                            const invalidKeys = [",", "."];

                            if (invalidKeys.includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onInput={(e) => {
                            e.target.value = parseInt(e.target.value) || 0;
                          }}
                          labelName="Estimativa de Volume:"
                          inputName="volume"
                          inputMask="offmask"
                          valuesInputs={valuesInputs}
                          setValuesInputs={setValuesInputs}
                          inputType="number"
                          isDisabled={checkNoInfoVolume || checkNoConsumptionVolume}
                        />
                        <div className="flex gap-2 justify-end items-center mt-[.5rem]">
                            <CheckNoInformation
                          name="volumeNoConsumption"
                          check={checkNoConsumptionVolume}
                          setCheck={setCheckNoConsumptionVolume}
                          setFieldValue={setFieldValue}
                          inputName="volume"
                          inputDefaultValue={0}
                          checkBoxText="Sem consumo no mês"
                        />
                           <CheckNoInformation
                          name="volumeNoInfo"
                          check={checkNoInfoVolume}
                          setCheck={setCheckNoInfoVolume}
                          setFieldValue={setFieldValue}
                          inputName="volume"
                          inputDefaultValue={''}
                        />

                        </div>
                      </div>
                      <div>
                        <Select
                          name="unidadeMedidaId"
                          label="*Medida: "
                          placeholder=""
                          options={optionPesquisaMedida}
                          noOptionsMessage="Medida não encontrado"
                          onChange={(e) => {
                            handleValue("unidadeMedidaId", e);
                            onChangePesquisaMedida(e);
                          }}
                          errors={errors.unidadeMedidaId}
                          touched={touched.unidadeMedidaId}
                          isDisabled={!pesquisaMedidasSelectEnabled}
                          {...pesquisaMedidaSelect}
                        />
                      </div>
                      <div>
                        <Select
                          name="prazoId"
                          label="*Prazo: "
                          placeholder=""
                          options={optionPesquisaPrazo}
                          noOptionsMessage="Prazo não encontrado"
                          onChange={(e) => {
                            handleValue("prazoId", e);
                            onChangePesquisaPrazo(e);
                          }}
                          errors={errors.prazoId}
                          touched={touched.prazoId}
                          {...pesquisaPrazoSelect}
                        />
                      </div>

                      <div>
                        {mostrarPrazoPersonalizado && (
                          <>
                            <InputField
                              labelName="*Prazo Personalizado (em dias):"
                              inputType="text"
                              inputName="outrosPrazos"
                              valuesInputs={valuesInputs}
                              setValuesInputs={setValuesInputs}
                              onKeyDown={(e) => {
                                const allowedCharacters = /[0-9/]/;
                                const currentValue = e.target.value;
                                const key = e.key;

                                if (
                                  (key?.length === 1 && !allowedCharacters.test(key)) ||
                                  (currentValue === "" && key === "/") ||
                                  (currentValue === "" && key === "0") ||
                                  (currentValue.slice(-1) === "/" && key === "0") ||
                                  (currentValue.slice(-1) === "/" && key === "/")
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onInput={(e) => {
                                let inputValue = e.target.value;

                                inputValue = inputValue.replace(/[^0-9/]/g, "");

                                const parts = inputValue.split("/");
                                let validInput = true;

                                for (let part of parts) {
                                  if (part?.length > 1 && part.startsWith("0")) {
                                    validInput = false;
                                    break;
                                  }
                                }

                                if (validInput) {
                                  e.target.value = inputValue;
                                } else {
                                  e.target.value = e.target.value.slice(0, -1);
                                }
                              }}
                            />
                          </>
                        )}
                      </div>

                      {trilhaCliente === "IND" && (
                        <>
                          <div>
                            <FormLabel className="field__label">
                              Preço FOB: <Info text="Sem valor de frete" bg="blue" />
                            </FormLabel>
                            <PriceInput
                              defaultValue={precoFob * 100}
                              setFieldValue={setFieldValue}
                              inputName="precoFinalFob"
                              setInput={setPrecoFob}
                              handleValue={handleValue}
                              inputMask="offmask"
                              inputType="text"
                              isDisabled={checkNoInfoFob}
                            />
                            <CheckNoInformation
                              name="noInfoPrecoFob"
                              check={checkNoInfoFob}
                              setCheck={setCheckNoInfoFob}
                              setFieldValue={setFieldValue}
                              inputName="precoFinalFob"
                              inputDefaultValue="R$ 0,00"
                            />
                          </div>
                          <div>
                            <FormLabel className="field__label">
                              Preço CIF: <Info text="Já incluso valor de frete" bg="blue" />
                            </FormLabel>
                            <PriceInput
                              setFieldValue={setFieldValue}
                              defaultValue={precoCif * 100}
                              inputName="precoFinalCif"
                              handleValue={handleValue}
                              setInput={setPrecoCif}
                              inputMask="offmask"
                              inputType="text"
                              isDisabled={checkNoInfoCif}
                            />
                            <CheckNoInformation
                              name="noInfoPrecoCif"
                              check={checkNoInfoCif}
                              setCheck={setCheckNoInfoCif}
                              setFieldValue={setFieldValue}
                              inputName="precoFinalCif"
                              inputDefaultValue="R$ 0,00"
                            />
                          </div>
                        </>
                      )}

                      {trilhaCliente === "TAC" && (
                        <>
                          <div>
                            <FormLabel className="field__label"> Sell In: </FormLabel>
                            <PriceInput
                              defaultValue={sellIn * 100}
                              setFieldValue={setFieldValue}
                              inputName="sellIn"
                              handleValue={handleValue}
                              setInput={setSellIn}
                              inputMask="offmask"
                              inputType="text"
                              isDisabled={checkNoInfoSellIn}
                            />
                            <CheckNoInformation
                              name="noInfoSellIn"
                              check={checkNoInfoSellIn}
                              setCheck={setCheckNoInfoSellIn}
                              setFieldValue={setFieldValue}
                              inputName="sellIn"
                              inputDefaultValue="R$ 0,00"
                            />
                          </div>
                          <div>
                            <FormLabel className="field__label"> Sell Out: </FormLabel>
                            <PriceInput
                              defaultValue={sellOut * 100}
                              setFieldValue={setFieldValue}
                              handleValue={handleValue}
                              inputName="sellOut"
                              setInput={setSellOut}
                              inputMask="offmask"
                              inputType="text"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </ContainerForm>

                  {showMessageForm.text ? (
                    <MessageForm
                      text={showMessageForm.text}
                      type={showMessageForm.type}
                      showMessage={showMessageForm}
                      setShowMessage={() =>
                        setShowMessageForm({
                          text: "",
                        })
                      }
                      closeCallback={() => {
                        const params = new URLSearchParams();
                        params.append("origem", origens.editar_pesquisa);

                        if (cameFromVisitaView) {
                          params.append("cameFromVisitaView", cameFromVisitaView);
                        }

                        navigate(`${initialPath}/pesquisa-de-preco/${idCliente}?${params.toString()}`);
                      }}
                      icon={showMessageForm.icon}
                    />
                  ) : null}
                </div>
                {loading && (
                  <div className="spinner__form ">
                    <Loader />
                  </div>
                )}

                {idCliente && idPesquisa && !showMessageForm.text && !loading && (
                  <div className="container mt-10">
                    <div className="flex gap-x-10">
                      <div className="flex-1">
                        <button
                          type="button"
                          onClick={toDelete}
                          className="relative flex w-full items-center justify-center text-white bg-[#FF2E00] px-8 py-4 rounded-full font-bold"
                        >
                          Excluir pesquisa
                          <div className="absolute right-2">
                            <SimulatorsTrash />
                          </div>
                        </button>
                      </div>

                      <div className="flex-1">
                        <button
                          type="button"
                          onClick={toDuplicate}
                          className="relative flex w-full items-center justify-center gap-x-2 text-white bg-primaria px-8 py-4 rounded-full font-bold"
                        >
                          Duplicar pesquisa
                          <div className="absolute right-6">
                            <DuplicateIcon />
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </Form>

              <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />
            </>
          )}
        </Formik>
      )}

      <ModalAction
        isOpen={isModalDeleteOpenAction}
        onClose={closeModalDeleteAction}
        title="Deseja deletar a pesquisa?"
        sub="A ação não pode ser revertida"
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={deleteConfirmed}
        linkTwo={closeModalDeleteAction}
      />

      <ModalAction
        isOpen={isModalRepeatedOpenAction}
        onClose={closeModalRepeatedAction}
        title="Esse produto já contém uma pesquisa vigente!"
        sub="Deseja seguir para a edição do produto?"
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={() => {
          closeModalRepeatedAction();
          navigate(
            `${initialPath}/pesquisa-de-preco/${idCliente}/editar/${pesquisaRepetidaId}?origem=${
              origens.editar_pesquisa
            }${searchParams.get("cameFromVisitaView") ? "&cameFromVisitaView=true" : ""}`
          );
        }}
        linkTwo={closeModalRepeatedAction}
      />
    </div>
  );
};

PriceSearchForm.propTypes = {
  dados: PropTypes.shape({
    trilha: PropTypes.shape({
      codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
  setShowButton: PropTypes.func.isRequired,
  origens: PropTypes.shape({
    editar_pesquisa: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  getOrigem: PropTypes.func.isRequired,
  origem: PropTypes.string,
  cameFromVisitaView: PropTypes.string,
};

PriceSearchForm.defaultProps = {
  dados: null,
};

const CheckNoInformation = ({ name, check, setCheck, setFieldValue, inputName, inputDefaultValue, checkBoxText = "Sem Informação" }) => {
  const handleChange = (e) => {
    const checked = e.target.checked;

    setCheck(checked);

    //  DEFINE O VALOR DO INPUT PARA O VALOR PADRÃO, GERALMENTE 0
    if (checked) {
      setFieldValue(inputName, inputDefaultValue);
    }

    setFieldValue(name, checked);
  };

  return (
    <div className={`check-line flex justify-end`}>
      <label className="check-label flex justify-end items-center">
        <span className="text-sm">{ checkBoxText }</span>
        <Checkbox className="ml-2" name={name} onChange={handleChange} isChecked={check} />
      </label>
    </div>
  );
};

CheckNoInformation.propTypes = {
  name: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  setCheck: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  inputDefaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PriceSearchForm;
